import React, { createContext } from "react";
/**
 * 現在のページ番号値と、そのsetterをContextに。
 */

export const initialViewerState = {
  currentPage: 1
};

const ViewerStateContext = React.createContext<ViewerState>(initialViewerState);

export default ViewerStateContext;
